import { createFileRoute, Navigate, Outlet } from '@tanstack/react-router';
import { z } from 'zod';
import { canAccessUserRegistry } from '../../../features/auth/admin-capabilities';
import { useAuth } from '../../../features/auth/auth-context';
import { defaultAdminHome } from '../../../features/auth/default-admin-home';

// URL — источник правды для фильтров реестра: ссылку со срезом можно
// переслать другому админу. Схема повторяет AdminUserListQuery, но
// оставляет всё опциональным: дефолты подставляет бэкенд.
const usersSearchSchema = z
  .object({
    search: z.string().optional(),
    cityId: z.uuid().optional(),
    createdFrom: z.string().optional(),
    createdTo: z.string().optional(),
    lastSeenFrom: z.string().optional(),
    lastSeenTo: z.string().optional(),
    botStatus: z.enum(['started', 'not_started', 'blocked']).optional(),
    referral: z.enum(['with', 'without']).optional(),
    referredById: z.uuid().optional(),
    adminRole: z.enum(['SUPERADMIN', 'CITY_MODERATOR']).optional(),
    includeFakes: z.boolean().optional(),
    sort: z.enum(['createdAt', 'lastSeenAt']).optional(),
    page: z.coerce.number().int().min(1).optional(),
  })
  .catch({});

export type UsersSearch = z.infer<typeof usersSearchSchema>;

export const Route = createFileRoute('/_authenticated/users')({
  staticData: { breadcrumb: 'Пользователи' },
  validateSearch: usersSearchSchema,
  component: UsersGuard,
});

function UsersGuard() {
  const { adminRoles } = useAuth();
  if (!canAccessUserRegistry(adminRoles)) {
    return <Navigate to={defaultAdminHome(adminRoles)} />;
  }
  return <Outlet />;
}
